import { Routes } from "@angular/router";
import { AuthGuard } from "./auth/auth.guard";
import { LayoutComponent } from "./layout/layout.component";
import { RedirectHomeComponent } from "./redirect-home/redirect-home.component";
import { RequirePasswordUpdateGuard } from "./auth/requirePasswordUpdate.guard";
const ɵ0 = () => import("./auth/auth.module.ngfactory").then((m) => m.AuthModuleNgFactory), ɵ1 = () => import("./cookies-policy/cookies-policy.module.ngfactory").then((m) => m.CookiesPolicyModuleNgFactory), ɵ2 = () => import("./privacy-policy/privacy-policy.module.ngfactory").then((m) => m.PrivacyPolicyModuleNgFactory), ɵ3 = () => import("./pages/joint-business-plan/joint-business-plan.module.ngfactory").then((m) => m.JointBusinessPlanModuleNgFactory), ɵ4 = () => import("./contact-campaign/contact-campaign.module.ngfactory").then((m) => m.ContactCampaignModuleNgFactory), ɵ5 = () => import("./dashboard/dashboard.module.ngfactory").then((m) => m.DashboardModuleNgFactory), ɵ6 = () => import("./planner/planner.module.ngfactory").then((m) => m.PlannerModuleNgFactory), ɵ7 = () => import("./planner-events/planner-events.module.ngfactory").then((m) => m.PlannerEventsModuleNgFactory), ɵ8 = () => import("./event/event.module.ngfactory").then((m) => m.EventModuleNgFactory), ɵ9 = () => import("./calendar/calendar.module.ngfactory").then((m) => m.CalendarMatrixModuleNgFactory), ɵ10 = () => import("./calendar-events/calendar-events.module.ngfactory").then((m) => m.CalendarEventsModuleNgFactory), ɵ11 = () => import("./trainings/trainings.module.ngfactory").then((m) => m.TrainingsModuleNgFactory), ɵ12 = () => import("./users/users.module.ngfactory").then((m) => m.UsersModuleNgFactory), ɵ13 = () => import("./localizations/localizations.module.ngfactory").then((m) => m.LocalizationsModuleNgFactory), ɵ14 = () => import("./reports/reports.module.ngfactory").then((m) => m.ReportsModuleNgFactory), ɵ15 = () => import("./admin/admin.module.ngfactory").then((m) => m.AdminModuleNgFactory), ɵ16 = () => import("./salons/salons.module.ngfactory").then((m) => m.SalonsModuleNgFactory), ɵ17 = () => import("./profile/profile.module.ngfactory").then((m) => m.ProfileModuleNgFactory), ɵ18 = () => import("./distributors/distributors.module.ngfactory").then((m) => m.DistributorsModuleNgFactory), ɵ19 = () => import("./participant/participant.module.ngfactory").then((m) => m.ParticipantModuleNgFactory);
const routes = [
    {
        path: "ssologin",
        redirectTo: "auth/ssologin",
        pathMatch: "prefix",
    },
    {
        path: "auth",
        loadChildren: ɵ0,
    },
    {
        path: "cookies-policy",
        loadChildren: ɵ1,
    },
    {
        path: "privacy-policy",
        loadChildren: ɵ2,
    },
    {
        path: "",
        component: LayoutComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: "",
                component: RedirectHomeComponent,
                canActivate: [RequirePasswordUpdateGuard],
            },
            {
                path: "jbp",
                loadChildren: ɵ3,
            },
            {
                path: "contact-campaign",
                loadChildren: ɵ4,
            },
            {
                path: "dashboard",
                loadChildren: ɵ5,
            },
            {
                path: "planner-old",
                loadChildren: ɵ6,
            },
            {
                path: "planner",
                loadChildren: ɵ7,
            },
            {
                path: "event",
                loadChildren: ɵ8,
            },
            {
                path: "calendar-old",
                loadChildren: ɵ9,
            },
            {
                path: "calendar",
                loadChildren: ɵ10,
            },
            {
                path: "trainings",
                loadChildren: ɵ11,
            },
            {
                path: "users",
                loadChildren: ɵ12,
            },
            {
                path: "localizations",
                loadChildren: ɵ13,
            },
            {
                path: "reports",
                loadChildren: ɵ14,
            },
            {
                path: "admin",
                loadChildren: ɵ15,
            },
            {
                path: "salons",
                loadChildren: ɵ16,
            },
            {
                path: "profile",
                loadChildren: ɵ17,
            },
            {
                path: "distributors",
                loadChildren: ɵ18,
            },
            {
                path: "participants",
                loadChildren: ɵ19,
            },
            {
                path: "**",
                redirectTo: "/",
                pathMatch: "full",
            },
        ],
    },
    {
        path: "**",
        redirectTo: "",
        pathMatch: "full",
    },
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2, ɵ3, ɵ4, ɵ5, ɵ6, ɵ7, ɵ8, ɵ9, ɵ10, ɵ11, ɵ12, ɵ13, ɵ14, ɵ15, ɵ16, ɵ17, ɵ18, ɵ19 };
